export const getBorderColor = (error) => {
  if (error?.message) {
    return "border-error-color focus:border-error-color";
  } else {
    return "border-grayDisplay-200 focus:border-grayDisplay-900";
  }
};
